const initialState = () => ({
  users: [],
});

const state = initialState();

export default state;
